import avatar from "../../../../assets/img/avatar.svg";

const From = ({ message }) => {
  return (
    <div className="row mx-0 mb-3 ">
      <div className="col-12 col-lg-3 d-flex px-lg-auto px-0 ">
        <div class="d-flex align-items-center overflow-hidden user-avatar-wrapper">
          <img
            src={
              message.from?.avatar !== undefined
                ? message.from?.avatar !== ""
                  ? message.from?.avatar
                  : avatar
                : avatar
            }
            width={40}
            height={40}
            style={{ borderRadius: "50%" }}
            className="img-fluid avatar m-0"
            alt={message.from?.name}
          />
        </div>
        <div className="flex-column d-flex justify-content-start ms-2 ">
          <span className="d-block text-cl-black-2 ff-univanova fz-12">{message.from?.name}</span>
          <span className="d-block text-cl-arsenic ff-univanova fz-10">{message.timeDistance}</span>
        </div>
      </div>
      <div className="col-11 col-lg-9 mt-lg-0 mt-2 px-0 px-lg">
        <div className="bg-cl-cultured-4 align-items-center px-3 py-2" style={{ borderRadius: "20px" }}>
          <span className="text-cl-black-2 fz-12 ff-univanova text-wrap">{message?.message}</span>
        </div>
      </div>
      {/* <div className="col-1 col-lg-1 btn-group px-lg-0">
                <button
                type="button"
                className="btn dropdown-toggle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                >
                <i className="bi bi-three-dots-vertical"></i>
                </button>
                <ul
                className="dropdown-menu"
                style={{ borderRadius: "10px" }}
                >
                <li>
                    <span
                    className="dropdown-item fz-14 ff-univanova-regular c-pointer text-decoration-underline text-cl-azure"
                    data-bs-toggle="modal"
                    data-bs-target="#myModalSingle"
                    >
                    Editar
                    </span>
                </li>
                <li>
                    <span className="dropdown-item fz-14 ff-univanova-regular text-prop-danger c-pointer text-decoration-underline text-cl-red">
                    Excluir
                    </span>
                </li>
                </ul>
            </div> */}
    </div>
  );
};

export default From;
